import { render } from "./abquestion.page.vue?vue&type=template&id=50b3fb82"
import script from "./abquestion.page.vue?vue&type=script&lang=js"
export * from "./abquestion.page.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__